import React, { useState } from 'react';
import { Checkbox, Grid, Typography } from '@material-ui/core';
import SearchBarWatchList from '../SearchBar';
import { ToolTipElement } from '../../Stock/ToolTipElement';
import FavouroiteTickerTable from '../favouriteTickerTable';
import InfoBox from '../infoBox';
import WatchListLoading from './WatchListLoading';
import TableOne from '../TableOne';
import moment from 'moment';
import axios from 'axios';
import { is_WeekendCalendarDate } from '../../../components/Modals/UOAModal/getDate';
import { fourMin, OptionsText, StockWatchList } from '../constants';
import DelIcon from '../delete.png';
import { makeStyles } from '@material-ui/core/styles';
import { BaseURL } from '../../../constants';

export const useStyles = makeStyles({
  root: {
    color: 'darkgrey',
    padding: 0,
    marginTop: 12,
    marginLeft: 8,
    width: 16,
    height: 0,
  },
  MuiSvgIcon: {
    root: {
      height: '0.25rem',
    },
  },
});

const WatchListSearch = ({
  styles,
  isMobile,
  setsnaktype,
  setFavLoading,
  setsnakMessage,
  setsnakOpen,
  userData,
  setfavTicker,
  favTicker,
  setwatchlistFavDeleteData,
  setdeleteCheck,
  setwatchlistFavDeleteModal,
  setwatchlistDeleteModal,
  setwatchListDeleteData,
  myFav,
  favLoading,
  filteredTickers,
  setShowModal,
  setType,
  deleteCheck,
  loading,
  zoomPercent,
  accessLevel,
  setmyFav,
}) => {
  const classes = useStyles();

  const [hoverTabelSortLabel, sethoverTabelSortLabel] = useState('');
  const [orderBy, setorderBy] = useState('');
  const [order, setorder] = useState();
  const [, setSelectedTicker] = useState(null);
  const [value, setValue] = useState(null);
  const onChange = (value) => {
    setValue(value);
  };

  const onSave = async (storeData) => {
    setSelectedTicker(storeData);
  };
  const goButton = async () => {
    let date = moment().format('YYYY-MM-DD');
    let datetoSend = is_WeekendCalendarDate(date);
    if (value) {
      setsnaktype('success');
      setFavLoading(true);
      try {
        const { status, data } = await axios.post(
          `${BaseURL}/api/storeFav?storeData=${value}&date=${datetoSend}&userId=${userData.sub}`
        );

        if (status === 200) {
          setsnakMessage('Ticker Added To Watchlist');
          setsnakOpen(true);
          const dataArray = data.map((dat) => {
            return {
              name: dat,
              value: false,
            };
          });

          setfavTicker(dataArray);
          setFavLoading(false);
          setValue('');
        }
      } catch (error) {
        setsnaktype('error');
        setsnakMessage(error.response.data.error);
        setsnakOpen(true);
        setFavLoading(false);
      }
    } else {
      setsnakMessage("Can't get Empty Ticker");
      setsnaktype('error');
      setsnakOpen(true);
    }
  };
  const setDeleteDataFavTick = () => {
    const DeletedValue = favTicker.filter((oneValue) => {
      return oneValue.value === true;
    });
    if (DeletedValue.length) {
      setwatchlistFavDeleteData(DeletedValue);
      setwatchlistFavDeleteModal(true);
    }
  };
  const setCheckboxes = (deleteCheck) => {
    setdeleteCheck(!deleteCheck);
  };
  const sortData = (type) => {
    setorderBy(type);
    const isAsc = orderBy === type && order === 'asc';
    const orderType = isAsc ? 'desc' : 'asc';
    setorder(orderType);
  };
  const setDeleteData = () => {
    const DeletedValue = myFav.filter((oneValue) => {
      return oneValue.value === true;
    });
    if (DeletedValue.length) {
      setwatchListDeleteData(DeletedValue);
      setwatchlistDeleteModal(true);
    }
  };
  return (
    <div style={styles.ContainerContent}>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={5} style={{ height: '100%' }}>
          <div
            style={isMobile ? styles.DivSearchMobile : { ...styles.DivSearch }}
          >
            <div
              style={
                isMobile
                  ? styles.StockWatchoptionTextMobile
                  : { ...styles.StockWatchoptionText }
              }
            >
              {StockWatchList}
            </div>
            <SearchBarWatchList
              favLoading={favLoading}
              isMobile={isMobile}
              value={value}
              goButton={goButton}
              onSave={onSave}
              filteredTickers={filteredTickers}
              onChange={onChange}
            />

            <div
              style={{ ...styles.delButton, marginTop: '5px' }}
              onClick={() => setDeleteDataFavTick()}
            >
              <img height="100%" width="100%" src={DelIcon} alt="" />
            </div>

            <div
              style={{
                marginTop: '7px',
                marginLeft: '1%',
                display: isMobile ? 'none' : '',
              }}
            >
              <ToolTipElement
                setShowModal={setShowModal}
                setType={setType}
                type={'watchlistadd'}
              />
            </div>
          </div>
          <Typography
            variant="body1"
            component="p"
            style={{
              ...styles.warningText,
              paddingTop: '27px',
              paddingLeft: '40px',
              color: 'gray',
              fontSize: '0.775rem',
              display: isMobile ? 'none' : '',
            }}
          >
            <span style={{ fontWeight: 'bold' }}> Important : </span> {fourMin}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={2} style={{ height: '100%' }}>
          <div style={isMobile ? styles.FavDivTableMobile : styles.FavDivTable}>
            <div
              style={{
                marginTop: '7px',
                marginLeft: '1%',
                display: !isMobile ? 'none' : '',
              }}
            >
              <ToolTipElement
                setShowModal={setShowModal}
                setType={setType}
                type={'watchlistadd'}
              />
            </div>
            <div>
              <FavouroiteTickerTable
                setfavTicker={setfavTicker}
                favTicker={favTicker}
                favLoading={favLoading}
              />
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={5}
          style={{ height: '100%', display: isMobile ? 'none' : '' }}
        >
          <InfoBox isMobile={isMobile} />
        </Grid>
      </Grid>

      <div style={styles.option}>
        <div style={isMobile ? styles.optionTextMobile : styles.optionText}>
          {' '}
          {OptionsText}
        </div>
        <Checkbox
          checked={deleteCheck}
          onClick={() => setCheckboxes(deleteCheck)}
          classes={{ root: classes.root }}
        />
        <div style={styles.delButton} onClick={() => setDeleteData()}>
          <img height="100%" width="100%" src={DelIcon} alt="" />
        </div>
        <div style={{ marginTop: '4px', marginLeft: '10px' }}>
          <ToolTipElement
            setShowModal={setShowModal}
            setType={setType}
            type={'watchlisttable'}
          />
        </div>
      </div>
      {loading ? (
        <WatchListLoading />
      ) : (
        <div
          style={{
            ...styles.tableDiv,
            zoom: zoomPercent,
            marginTop: isMobile ? '7px' : '',
          }}
        >
          <TableOne
            accessLevel={accessLevel}
            isMobile={isMobile}
            sortData={sortData}
            hoverTabelSortLabel={hoverTabelSortLabel}
            sethoverTabelSortLabel={sethoverTabelSortLabel}
            orderBy={orderBy}
            setorderBy={setorderBy}
            setmyFav={setmyFav}
            order={order}
            setorder={setorder}
            myFav={myFav}
            deleteCheck={deleteCheck}
          />
        </div>
      )}
    </div>
  );
};
export default WatchListSearch;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/components/WatchListSearch.jsx